import { observer } from "mobx-react-lite";
import React from "react";
import { render } from "react-dom";
import { Helmet } from "react-helmet";

export const deviceFingerPrintID = new Date().getTime();
export const merchantID = "visanetgt_inapgob";

export default observer(function Validadrs() {

    const orgID = "1snn5n9w";
    const orgIDProd = "k8vif92e";
    const sessionID = merchantID + deviceFingerPrintID;

    const cyberScriptUrl = `https://h.online-metrix.net/fp/tags.js?org_id=${encodeURI(orgIDProd)}&session_id=${encodeURI(sessionID)}`;
    const cyberScriptUrlObj = `https://h.online-metrix.net/fp/tags?org_id=${encodeURI(orgIDProd)}&session_id=${encodeURI(sessionID)}`;
    
    var noscript = document.createElement('noscript')
    var iframe = document.createElement('iframe')
    iframe.setAttribute("height", "100px")
    iframe.setAttribute("width", "100px")
    iframe.setAttribute("border", "0")
    iframe.setAttribute("position", "absolute")
    iframe.setAttribute("top", "-5000px")
    iframe.setAttribute('src', cyberScriptUrlObj)
    noscript.appendChild(iframe)
    document.body.appendChild(noscript)

    return (

        <div className="application">
            <Helmet>
                <script type="text/javascript" src={cyberScriptUrl}></script>
            </Helmet>
        </div>

    );
});
